import { render, staticRenderFns } from "./TelegramNotificationList.vue?vue&type=template&id=55d24dd5&scoped=true&"
import script from "./TelegramNotificationList.vue?vue&type=script&lang=js&"
export * from "./TelegramNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./TelegramNotificationList.vue?vue&type=style&index=0&id=55d24dd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d24dd5",
  null
  
)

export default component.exports